<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Administração de Loteamentos';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Conheça nossos serviços na área de Administração de Loteamentos - Associação de Moradores.</p>
	<hr>
	<div class="box-itens-icon grid grid-size--1 grid-size-sm--1">

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Instituição</h2>
				<p>
					Auxiliamos os proprietários de lotes em loteamentos, a criarem uma associação de moradores, sem fins lucrativos, visando atender os associados frente à organização do bairro como um todo.
				</p>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">O Estatuto Social</h2>
				<p>Assessoria na elaboração do Estatuto Social o qual irá disciplinar as relações entre os associados, determinando os direitos, deveres e obrigações, inclusive estipulando a obrigatoriedade do pagamento de uma contribuição mensal, (conforme previsão orçamentária aprovada em assembleia de moradores)*.</p>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Auxiliar de Administração</h2>
				<p>Executamos os trabalhos de auxiliar dos serviços administrativos da associação (contratação de portaria, ronda, e demais funcionários necessários ao empreendimento), serviços financeiros (pagamento de contas e recebimento da contribuição mensal a qual é paga por todos através de boleto bancário), serviços contábeis (mensalmente é prestado contas a todos os associados através de balancetes, onde são discriminadas todas as despesas e receitas realizadas no mês) e serviços jurídicos (análise de contratos, orientações, cobrança dos associados inadimplentes)*.</p>
			</div>
		</div>

	</div>
	<br />

	<p>*Serviços sujeitos à cobrança.</p>

	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>

</div>